import { useContext } from "react";
import { AppContext } from "../../contexts/app";
import { ACTIONS } from "../../contexts/app/actions";

const useDrawer = () => {
  const { state, dispatch } = useContext(AppContext);
  const { isOpen, content, handleClose, props } = state.drawer;

  const openDrawer = (value) => {
    dispatch({
      type: ACTIONS.OPEN_DRAWER,
      value: {
        content: null,
        handleClose: null,
        props: {},
        ...value,
      },
    });
  };

  const closeDrawer = () => {
    if (handleClose) {
      handleClose();
    }
    dispatch({ type: ACTIONS.CLOSE_DRAWER });
  };

  const setContent = (content) => {
    dispatch({ type: ACTIONS.SET_DRAWER_CONTENT, value: content });
  };

  return { isOpen, props, content, openDrawer, closeDrawer, setContent };
};

export default useDrawer;
